import React, {useState} from 'react';
import {
  LoginBox,
  Copyright,
  PhraseHighlighted,
  WhatsAppBusinessLogoIcon,
  SkewedBackground,
  AlertMessage
} from 'components';

import { useHistory } from 'react-router-dom';
import { AuthServiceLogin, MessageRequest } from 'services';

import './login.scss';

export const LoginPage = () => {
  const history = useHistory();
  const [message, setMessage] = useState("");
  const [active, setActive] = useState(false);

  const toggle = (value) => {
    setActive(value);
  }

  const getLoginData = (data) => {
    AuthServiceLogin(data)
      .then(() => {
        history.push('/dashboard');
      }).catch((response) => {
        const errorMessage = 'Usuário ou senha inválidos! Tente novamente.'
        MessageRequest("Marca cadastrada", response, setMessage, setActive, errorMessage);
      });
  };

  return (
    <main className="m-0 p-0 login-page">
      <SkewedBackground />
      <div className="login-page--wrapper">
        <WhatsAppBusinessLogoIcon />
        <PhraseHighlighted phrase={'Faça login na sua conta...'} />
      </div>
      <LoginBox loginData={getLoginData}></LoginBox>
      <Copyright />
      <AlertMessage message={message} active={active} toggle={toggle} />
    </main>
  );
};
